import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getExportAssetsFile } from '@api/exportAssets';

import { TExportAssetsDTO } from '@interfaces/assets/dto/assetsDTO';

import { ESnackbarTypes } from '@enums/common';

import { EXPORT_ASSET_FILE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportAssetsFile = () => {
	const dispatch = useAppDispatch();

	const {
		mutate: handlePreparingExport,
		isLoading: isLoadingExportAssetsFile,
	} = useMutation<TExportAssetsDTO>({
		mutationKey: [EXPORT_ASSET_FILE],
		mutationFn: getExportAssetsFile,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		refetchOnWindowFocus: false,
	});

	return {
		handlePreparingExport,
		isLoadingExportAssetsFile,
	};
};
